"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesHedgeGridProcessor = void 0;
const react_1 = require("react");
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const apis_1 = require("./apis");
const lodash_1 = require("lodash");
const GridTradingUtils_1 = require("../GridTradingUtils");
const GridV4FuturesProcessor_1 = require("./GridV4FuturesProcessor");
const operators_1 = require("rxjs/operators");
const rxjs_1 = require("rxjs");
var GridV4FuturesHedgeGridProcessor;
(function (GridV4FuturesHedgeGridProcessor) {
    // 下单二次确认框参数
    GridV4FuturesHedgeGridProcessor.useConfirmSheetDataForUI = ({ orderData, symbol, currentPrice, $st, }) => {
        const longOrderData = orderData[TradeAPILib_1.GridFuturesTrend.long];
        const shortOrderData = orderData[TradeAPILib_1.GridFuturesTrend.short];
        // 总投资额
        const totalInvest = (0, react_1.useMemo)(() => {
            return new trade_utils_lib_1.SafeDecimal((longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.quote_investment) || 0).add((shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.quote_investment) || 0).toString();
        }, [longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.quote_investment, shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.quote_investment]);
        // 杠杆后总投资额
        const totalInvestLeverage = (0, react_1.useMemo)(() => {
            const _getInvest = (trend) => {
                const d = orderData[trend];
                if (!d)
                    return "0";
                return new trade_utils_lib_1.SafeDecimal(d.quote_investment || 0).mul(d.leverage || 1);
            };
            return new trade_utils_lib_1.SafeDecimal(_getInvest(TradeAPILib_1.GridFuturesTrend.long)).add(_getInvest(TradeAPILib_1.GridFuturesTrend.short)).toString();
        }, [orderData]);
        // 杠杆倍数
        const leverage = (0, react_1.useMemo)(() => {
            return (longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.leverage) || (shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.leverage);
        }, [longOrderData === null || longOrderData === void 0 ? void 0 : longOrderData.leverage, shortOrderData === null || shortOrderData === void 0 ? void 0 : shortOrderData.leverage]);
        // 动态保证金
        const extraMarginAmount = orderData.extra_margin_amount;
        const { tradeInfo, loading } = GridV4FuturesHedgeGridProcessor.useTradeInfo({ isFocused: true, orderData, currentPrice });
        const liquidPrice = (0, react_1.useMemo)(() => {
            var _a, _b;
            let liquidUp = (_a = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _a === void 0 ? void 0 : _a.estimate_liquidation_price;
            let liquidDown = (_b = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _b === void 0 ? void 0 : _b.estimate_liquidation_price;
            return { up: liquidUp, down: liquidDown };
        }, [tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long, tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short]);
        // // 订单参数展示
        // const long = useTrendOrderForUI({
        //     data: longOrderData,
        //     liquidPrice,
        //     symbolInfo: symbol[GridFuturesTrend.long],
        //     tradeAPI,
        //     $st,
        //     $num,
        // });
        // const short = useTrendOrderForUI({
        //     data: shortOrderData,
        //     liquidPrice,
        //     symbolInfo: symbol[GridFuturesTrend.short],
        //     tradeAPI,
        //     $st,
        //     $num,
        // });
        const quoteDisplay = (0, react_1.useMemo)(() => {
            const s = symbol[TradeAPILib_1.GridFuturesTrend.long] || symbol[TradeAPILib_1.GridFuturesTrend.short];
            if (!s) {
                return "";
            }
            return s.quoteDisplay;
        }, [symbol]);
        // 开单参数
        const createOrderParams = (0, react_1.useMemo)(() => {
            return [
                { label: $st("trade_leverage"), value: `${leverage ? `${leverage}x` : "--"}` },
                {
                    label: $st("hedge_grid_total_actual_invest"),
                    value: `${totalInvest !== null && totalInvest !== void 0 ? totalInvest : "--"} ${quoteDisplay}`,
                },
                { label: $st("hedge_grid_total_leverage_actual_invest"), value: `${totalInvestLeverage !== null && totalInvestLeverage !== void 0 ? totalInvestLeverage : "--"} ${quoteDisplay}` },
                { label: $st("hedge_grid_total_margin"), value: `${extraMarginAmount || "0"} ${quoteDisplay}` },
            ];
        }, [$st, extraMarginAmount, leverage, quoteDisplay, totalInvest, totalInvestLeverage]);
        const tradeInfoCacheRef = (0, react_1.useRef)(tradeInfo);
        // 投资额分布
        const percent = (0, react_1.useMemo)(() => {
            var _a, _b, _c, _d, _e, _f;
            // 这里默认多空两个单的币对是同一种，后期如果支持不同币对时，需要重新计算
            if (loading && !tradeInfoCacheRef.current)
                return ["0%", "0%", "0%"];
            tradeInfoCacheRef.current = tradeInfo;
            const longEsPosition = new trade_utils_lib_1.SafeDecimal(((_a = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _a === void 0 ? void 0 : _a.estimate_position_occupy_margin) || 0);
            const longEsOrder = new trade_utils_lib_1.SafeDecimal(((_b = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _b === void 0 ? void 0 : _b.estimate_order_occupy_margin) || 0);
            const longEsFee = new trade_utils_lib_1.SafeDecimal(((_c = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _c === void 0 ? void 0 : _c.estimate_fee) || 0);
            const shortEsPosition = new trade_utils_lib_1.SafeDecimal(((_d = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _d === void 0 ? void 0 : _d.estimate_position_occupy_margin) || 0);
            const shortEsOrder = new trade_utils_lib_1.SafeDecimal(((_e = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _e === void 0 ? void 0 : _e.estimate_order_occupy_margin) || 0);
            const shortEsFee = new trade_utils_lib_1.SafeDecimal(((_f = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _f === void 0 ? void 0 : _f.estimate_fee) || 0);
            const esMargin = new trade_utils_lib_1.SafeDecimal((tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_extra_margin) || 0);
            const totalD = longEsPosition
                .add(longEsOrder)
                .add(longEsFee)
                .add(shortEsPosition)
                .add(shortEsOrder)
                .add(shortEsFee)
                .add(esMargin);
            const basePercentD = longEsPosition.add(shortEsPosition).div(totalD).mul(100).toDecimalPlaces(2);
            let quotePercentD = longEsOrder.add(shortEsOrder).add(longEsFee).add(shortEsFee).div(totalD).mul(100).toDecimalPlaces(2);
            let otherD = new trade_utils_lib_1.SafeDecimal(100).sub(basePercentD).sub(quotePercentD);
            // 如果额外保证金为0的话，那么不应该有预留资金。
            if (esMargin.eq(0)) {
                quotePercentD = new trade_utils_lib_1.SafeDecimal(100).sub(basePercentD);
                otherD = new trade_utils_lib_1.SafeDecimal(0);
            }
            if (basePercentD.isNaN() || quotePercentD.isNaN() || otherD.isNaN()) {
                return ["0%", "0%", "0%"];
            }
            return [basePercentD.toString() + "%", quotePercentD.toString() + "%", otherD.toString() + "%"];
        }, [loading, tradeInfo]);
        // 强平价在区间内提示
        const liquidPriceInRangeTips = (0, react_1.useMemo)(() => {
            let top;
            let bottom;
            if (longOrderData && shortOrderData) {
                top = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(longOrderData.top), new trade_utils_lib_1.SafeDecimal(shortOrderData.top));
                bottom = trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(longOrderData.bottom), new trade_utils_lib_1.SafeDecimal(shortOrderData.bottom));
            }
            else {
                if (longOrderData) {
                    top = new trade_utils_lib_1.SafeDecimal(longOrderData.top);
                    bottom = new trade_utils_lib_1.SafeDecimal(longOrderData.bottom);
                }
                if (shortOrderData) {
                    top = new trade_utils_lib_1.SafeDecimal(shortOrderData.top);
                    bottom = new trade_utils_lib_1.SafeDecimal(shortOrderData.bottom);
                }
            }
            // const top = SafeDecimal.max(orderData?.long?.top || 0, orderData?.short?.top || 0);
            // const bottom = SafeDecimal.min(orderData?.long?.bottom || 0, orderData?.short?.bottom || 0);
            // console.log("============== start 22222222 ===================");
            // console.log(`${bottom} ~ ${top}`);
            // console.log(`${liquidPrice.down} ~ ${liquidPrice.up} `);
            // console.log(liquidPrice.down, ">", bottom);
            // console.log(liquidPrice.up, "<", top);
            // console.log("============== end 22222222 =====================");
            if (liquidPrice.up &&
                liquidPrice.down &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.up).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.up).greaterThan(bottom) &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.down).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.down).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_in");
            }
            else if (liquidPrice.up &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.up).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.up).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_up");
            }
            else if (liquidPrice.down &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.down).lessThan(top) &&
                new trade_utils_lib_1.SafeDecimal(liquidPrice.down).greaterThan(bottom)) {
                return $st("hedge_grid_liquid_tips_down");
            }
        }, [$st, liquidPrice.down, liquidPrice.up, longOrderData, shortOrderData]);
        return {
            createOrderParams,
            percent,
            liquidPrice,
            loading,
            // long,
            // short,
            liquidPriceInRangeTips,
        };
    };
    // 获取单个订单展示参数
    GridV4FuturesHedgeGridProcessor.useTrendOrderForUI = ({ data, liquidPrice, symbolInfo, tradeAPI, $st, $num, }) => {
        var _a, _b, _c, _d, _e;
        // 单网格利润率
        const [fee, feeError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbolInfo, tradeAPI, TradeAPILib_1.ExchangeID.PIONEXV2, "maker");
        const shortProfitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid((data === null || data === void 0 ? void 0 : data.grid_type) || "arithmetic", (data === null || data === void 0 ? void 0 : data.top) || "0", (data === null || data === void 0 ? void 0 : data.bottom) || "0", (_b = (_a = data === null || data === void 0 ? void 0 : data.row) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0", fee, (_c = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _c !== void 0 ? _c : 0);
        const profitPerGridDesc = GridTradingUtils_1.GridTradingUtils.useProfitPerGridDesc(shortProfitPerGrid);
        if (!data || feeError || !symbolInfo)
            return null;
        const symbolDisplay = `${(symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay) || ""}${(symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay) || ""} ${$st("futures_perpetual_short")}`;
        const gridTypeTrans = (data === null || data === void 0 ? void 0 : data.grid_type) === TradeAPILib_1.GRID_TYPE.arithmetic ? $st("grid_arithmetic_short") : $st("grid_geometric_short");
        const obj = [
            { label: $st("trade_pair"), value: symbolDisplay },
            {
                label: $st("grid_pro_price_interval"),
                value: `${$num((data === null || data === void 0 ? void 0 : data.bottom) || 0, { precision: (_d = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _d !== void 0 ? _d : 4 })}-${$num((data === null || data === void 0 ? void 0 : data.top) || 0, {
                    precision: (_e = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _e !== void 0 ? _e : 4,
                })}`,
            },
            { label: $st("gird_row_count"), value: `${(data === null || data === void 0 ? void 0 : data.row) || 0} ${gridTypeTrans}` },
            { label: $st("trade_profit_per_grid_no_fee_br"), value: `${profitPerGridDesc}` },
            { label: $st("grid_invest_pro"), value: `${data === null || data === void 0 ? void 0 : data.quote_investment} (${data === null || data === void 0 ? void 0 : data.leverage}x)` },
        ];
        if (liquidPrice) {
            obj.push({ label: $st("est_liq_price"), value: liquidPrice, type: "liquidPrice" });
        }
        return obj;
    };
    GridV4FuturesHedgeGridProcessor.useUserParams = ({ symbolInfo, currentPrice, isFocused }) => {
        // 汇总数据
        const [orderData, setOrderData] = (0, react_1.useState)();
        const updateOrderData = (0, react_1.useCallback)((type, v) => {
            setOrderData((s) => {
                const d = s === null || s === void 0 ? void 0 : s[type];
                // 兼容删除
                if (!v && d) {
                    s === null || s === void 0 ? true : delete s[type];
                    return s;
                }
                return Object.assign(Object.assign({}, s), { [type]: Object.assign(Object.assign({}, d), v) });
            });
        }, []);
        // 设置额外保证金
        const setExtraMarginAmount = (0, react_1.useCallback)((v) => setOrderData((s) => (Object.assign(Object.assign({}, s), { extra_margin_amount: v }))), []);
        // 总投资额
        const totalInvest = (0, react_1.useMemo)(() => {
            var _a, _b;
            if (!(orderData === null || orderData === void 0 ? void 0 : orderData.long) && !(orderData === null || orderData === void 0 ? void 0 : orderData.short)) {
                return "";
            }
            return new trade_utils_lib_1.SafeDecimal(((_a = orderData === null || orderData === void 0 ? void 0 : orderData.long) === null || _a === void 0 ? void 0 : _a.quote_investment) || 0).add(((_b = orderData === null || orderData === void 0 ? void 0 : orderData.short) === null || _b === void 0 ? void 0 : _b.quote_investment) || 0).toString();
        }, [orderData === null || orderData === void 0 ? void 0 : orderData.long, orderData === null || orderData === void 0 ? void 0 : orderData.short]);
        // 杠杆后总投资额
        const totalInvestLeverage = (0, react_1.useMemo)(() => {
            var _a, _b, _c, _d;
            if (!(orderData === null || orderData === void 0 ? void 0 : orderData.long) && !(orderData === null || orderData === void 0 ? void 0 : orderData.short)) {
                return "";
            }
            const longInvest = new trade_utils_lib_1.SafeDecimal(((_a = orderData === null || orderData === void 0 ? void 0 : orderData.long) === null || _a === void 0 ? void 0 : _a.quote_investment) || 0).mul(((_b = orderData === null || orderData === void 0 ? void 0 : orderData.long) === null || _b === void 0 ? void 0 : _b.leverage) || 1);
            const shortInvest = new trade_utils_lib_1.SafeDecimal(((_c = orderData === null || orderData === void 0 ? void 0 : orderData.short) === null || _c === void 0 ? void 0 : _c.quote_investment) || 0).mul(((_d = orderData === null || orderData === void 0 ? void 0 : orderData.short) === null || _d === void 0 ? void 0 : _d.leverage) || 1);
            return longInvest.add(shortInvest).toString();
        }, [orderData === null || orderData === void 0 ? void 0 : orderData.long, orderData === null || orderData === void 0 ? void 0 : orderData.short]);
        // 获取检查信息
        const { tradeInfo, loading: tradeInfoLoading, getNewTradeInfo } = GridV4FuturesHedgeGridProcessor.useTradeInfo({ currentPrice, orderData, isFocused });
        const orderDataRef = (0, react_1.useRef)(orderData);
        orderDataRef.current = orderData;
        const currentPriceRef = (0, react_1.useRef)(currentPrice);
        currentPriceRef.current = currentPrice;
        const getRequestInfo = (0, react_1.useCallback)(({ bu_order_id, trend }) => {
            return getNewTradeInfo().pipe((0, operators_1.mergeMap)(() => {
                const _orderData = orderDataRef.current;
                const slippageControlFormat = ({ item, trend }) => {
                    if (!item || !symbolInfo)
                        return;
                    // 开单限价转换
                    if (item.slippageControl) {
                        const [open_position_buy_limit, open_position_sell_limit] = (0, GridTradingUtils_1.GridCheckOpenPositionPriceLimit)(item.slippageControl, item.condition || "", currentPriceRef.current || "", false, trend, symbolInfo);
                        item.open_position_buy_limit = open_position_buy_limit;
                        item.open_position_sell_limit = open_position_sell_limit;
                    }
                    delete item.slippageControl;
                    delete item.isRunning;
                    delete item.profit;
                    delete item.profitRate;
                    item.open_price = new trade_utils_lib_1.SafeDecimal(currentPriceRef.current).toString(); // 防止科学计数法
                    item.loss_stop_delay = new trade_utils_lib_1.SafeDecimal(item.loss_stop_delay).toNumber(); // 后端需要数字类型
                    item.profit_stop_delay = new trade_utils_lib_1.SafeDecimal(item.profit_stop_delay).toNumber(); // 后端需要数字类型
                };
                slippageControlFormat({ item: _orderData === null || _orderData === void 0 ? void 0 : _orderData.long, trend: TradeAPILib_1.GridFuturesTrend.long });
                slippageControlFormat({ item: _orderData === null || _orderData === void 0 ? void 0 : _orderData.short, trend: TradeAPILib_1.GridFuturesTrend.short });
                const gridV4FuturesHedgeGrid = Object.assign(Object.assign({}, _orderData), { extra_margin: (_orderData === null || _orderData === void 0 ? void 0 : _orderData.extra_margin_amount) || "0", loss_stop_delay: new trade_utils_lib_1.SafeDecimal(_orderData === null || _orderData === void 0 ? void 0 : _orderData.loss_stop_delay).toNumber(), profit_stop_delay: new trade_utils_lib_1.SafeDecimal(_orderData === null || _orderData === void 0 ? void 0 : _orderData.profit_stop_delay).toNumber() });
                delete gridV4FuturesHedgeGrid.extra_margin_amount;
                delete gridV4FuturesHedgeGrid.copyFrom;
                delete gridV4FuturesHedgeGrid.copyType;
                // 追加订单时 只需要传追加的订单即可，已有的订单不能传给后端
                if (trend) {
                    if (trend === TradeAPILib_1.GridFuturesTrend.long) {
                        delete gridV4FuturesHedgeGrid.short;
                    }
                    else {
                        delete gridV4FuturesHedgeGrid.long;
                    }
                }
                return (0, rxjs_1.of)({
                    bu_order_id,
                    copyFrom: _orderData === null || _orderData === void 0 ? void 0 : _orderData.copyFrom,
                    copyType: _orderData === null || _orderData === void 0 ? void 0 : _orderData.copyType,
                    orderType: TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid,
                    gridV4FuturesHedgeGrid,
                });
            }));
        }, [getNewTradeInfo, symbolInfo]);
        return {
            orderData,
            setOrderData,
            updateOrderData,
            setExtraMarginAmount,
            totalInvest,
            totalInvestLeverage,
            tradeInfo,
            tradeInfoLoading,
            getRequestInfo,
            orderPreCheck: getNewTradeInfo,
        };
    };
    // 创建子网格控制器
    GridV4FuturesHedgeGridProcessor.useTrendOrderManager = ({ symbolInfo, extra_margin_amount, available, tradeAPI, trend, orderData, currentPrice, isFocused, isAppendMode, $st, $num, }) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const addedTrendOrderData = (0, react_1.useMemo)(() => {
            if (trend === TradeAPILib_1.GridFuturesTrend.long) {
                return orderData === null || orderData === void 0 ? void 0 : orderData.short;
            }
            else if (trend === TradeAPILib_1.GridFuturesTrend.short) {
                return orderData === null || orderData === void 0 ? void 0 : orderData.long;
            }
        }, [orderData === null || orderData === void 0 ? void 0 : orderData.long, orderData === null || orderData === void 0 ? void 0 : orderData.short, trend]);
        // 数据汇总
        const [data, setDataBase] = (0, react_1.useState)({
            base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.base,
            quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quote,
            leverage: (_a = addedTrendOrderData === null || addedTrendOrderData === void 0 ? void 0 : addedTrendOrderData.leverage) !== null && _a !== void 0 ? _a : 3,
            grid_type: TradeAPILib_1.GRID_TYPE.arithmetic,
            isRunning: false,
            profit: "",
            profitRate: "",
        });
        // 更新数据
        const setData = (0, react_1.useCallback)((v) => setDataBase((s) => (Object.assign(Object.assign({}, s), v))), []);
        // 数据回填 编辑等情况
        (0, react_1.useEffect)(() => {
            if (orderData === null || orderData === void 0 ? void 0 : orderData[trend]) {
                setData(orderData[trend]);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        // 错误文案
        const [errors, setErrors] = (0, react_1.useState)({});
        // 手续费
        const [fee, feeError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbolInfo, tradeAPI, TradeAPILib_1.ExchangeID.PIONEXV2, "maker");
        // 单网格利润率
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid(data.grid_type, data.top || "0", data.bottom || "0", (_c = (_b = data.row) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : "0", fee, (_d = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _d !== void 0 ? _d : 0);
        const profitPerGridDesc = GridTradingUtils_1.GridTradingUtils.useProfitPerGridDesc(profitPerGrid);
        // 格子数量
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(data.top || "0", data.bottom || "0", data.grid_type, fee, (_e = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _e !== void 0 ? _e : 0, GridV4FuturesProcessor_1.GridV4FuturesMaxGrids);
        // 预检查数据
        const { loading: tradeInfoLoading, tradeInfo } = GridV4FuturesHedgeGridProcessor.useTradeInfo({ trend, data, orderData, currentPrice, isFocused });
        const orderTradeInfo = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo[trend];
        // 格子数 范围
        const rowRange = (0, react_1.useMemo)(() => {
            return {
                min: GridV4FuturesProcessor_1.GridV4FuturesMinGrids,
                max: calcuGridsMax,
            };
        }, [calcuGridsMax]);
        // 投资额范围
        const investRange = (0, react_1.useMemo)(() => {
            const min = orderTradeInfo === null || orderTradeInfo === void 0 ? void 0 : orderTradeInfo.min_investment;
            const max = orderTradeInfo === null || orderTradeInfo === void 0 ? void 0 : orderTradeInfo.max_investment;
            const used = isAppendMode ? 0 : (addedTrendOrderData === null || addedTrendOrderData === void 0 ? void 0 : addedTrendOrderData.quote_investment) || 0;
            // 剩余可投金额
            let limit = new trade_utils_lib_1.SafeDecimal(max).sub(used).toString();
            if (new trade_utils_lib_1.SafeDecimal(limit).lessThan(0)) {
                limit = "0";
            }
            const minDisplay = min ? $num(min, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision, rounding: "ceil" }) : undefined;
            const maxDisplay = max ? $num(max, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) : undefined;
            const usedDisplay = used ? $num(used, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) : undefined;
            const limitDisplay = limit ? $num(limit, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }) : undefined;
            return { min, max, limit, used, minDisplay, maxDisplay, limitDisplay, usedDisplay };
        }, [
            $num,
            addedTrendOrderData === null || addedTrendOrderData === void 0 ? void 0 : addedTrendOrderData.quote_investment,
            isAppendMode,
            orderTradeInfo === null || orderTradeInfo === void 0 ? void 0 : orderTradeInfo.max_investment,
            orderTradeInfo === null || orderTradeInfo === void 0 ? void 0 : orderTradeInfo.min_investment,
            symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
        ]);
        // 错误检查
        (0, react_1.useEffect)(() => {
            const e = {};
            // 网格数量错误
            if (data.row !== undefined) {
                if (data.row < rowRange.min) {
                    e.row = $st("grid_count_need_bigger_than", { value: rowRange.min });
                }
                if (data.row > rowRange.max) {
                    e.row = $st("grid_count_need_lower_than", { value: rowRange.max });
                }
            }
            // 价格区间 错误
            if (data.top !== undefined && data.bottom !== undefined) {
                const result = GridTradingUtils_1.GridTradingUtils.checkPriceError(data.bottom, data.top, $st, trend, currentPrice);
                if (result) {
                    e.price = result;
                }
            }
            // 投资额范围错误
            if (data.quote_investment && investRange.min && investRange.max) {
                if (new trade_utils_lib_1.SafeDecimal(data.quote_investment).lessThan(investRange.min)) {
                    e.investRange = `${$st("trade_invest_need")}≥${investRange.minDisplay}`;
                }
                if (new trade_utils_lib_1.SafeDecimal(data.quote_investment).greaterThan(investRange.limit)) {
                    e.investRange = `${$st("trade_invest_need")}≤${investRange.limitDisplay}`;
                }
            }
            setErrors(e);
        }, [
            $st,
            currentPrice,
            data.bottom,
            data.quote_investment,
            data.row,
            data.top,
            investRange.limit,
            investRange.limitDisplay,
            investRange.max,
            investRange.maxDisplay,
            investRange.min,
            investRange.minDisplay,
            rowRange.max,
            rowRange.min,
            trend,
        ]);
        const liquidPrice = (0, react_1.useMemo)(() => {
            var _a, _b;
            return {
                up: (_a = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _a === void 0 ? void 0 : _a.estimate_liquidation_price,
                down: (_b = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _b === void 0 ? void 0 : _b.estimate_liquidation_price,
            };
        }, [(_f = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.long) === null || _f === void 0 ? void 0 : _f.estimate_liquidation_price, (_g = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.short) === null || _g === void 0 ? void 0 : _g.estimate_liquidation_price]);
        return {
            data,
            setData,
            setDataBase,
            errors,
            tradeInfo: orderTradeInfo,
            tradeInfoLoading,
            profitPerGrid,
            profitPerGridDesc: `${$st("grid_futures_es_profit_per_grid_with_fee")}: ${profitPerGridDesc}`,
            rowRange,
            investRange,
            liquidPrice,
        };
    };
    GridV4FuturesHedgeGridProcessor.useTradeInfo = (params) => {
        const [loading, setLoading] = (0, react_1.useState)(false);
        const paramsRef = (0, react_1.useRef)(params);
        paramsRef.current = params;
        const { data, trend, orderData, currentPrice } = params;
        const [tradeInfo, setTradeInfo] = (0, react_1.useState)();
        const requireField = (0, react_1.useMemo)(() => ["base", "quote", "open_price", "grid_type", "row", "top", "bottom", "quote_investment", "leverage"], []);
        const requireFieldCheck = (0, react_1.useCallback)((d) => {
            if (!d)
                return false;
            return requireField.every((k) => {
                return k in d || requireField[k] === "";
            });
        }, [requireField]);
        const getRequestInfo = (0, react_1.useCallback)(() => {
            var _a, _b, _c;
            const _data = paramsRef.current.data;
            const mergeParams = (d) => {
                if (!d)
                    return;
                const openPrice = d.open_price ? d.open_price : d.condition || paramsRef.current.currentPrice;
                const _params = Object.assign(Object.assign({}, d), { quote_investment: d.quote_investment ? d.quote_investment : "0", open_price: openPrice ? new trade_utils_lib_1.SafeDecimal(openPrice).toString() : undefined });
                const _obj = {};
                // 请求参数过滤, 仅传后端接口需要的字段，要不然后端接口要报错
                requireField.forEach((k) => {
                    if (_params[k] !== undefined) {
                        _obj[k] = _params[k];
                    }
                });
                return _obj;
            };
            const params = {
                extra_margin: false,
                extra_margin_amount: ((_a = paramsRef.current.orderData) === null || _a === void 0 ? void 0 : _a.extra_margin_amount) || "0",
                long: mergeParams((_b = paramsRef.current.orderData) === null || _b === void 0 ? void 0 : _b.long),
                short: mergeParams((_c = paramsRef.current.orderData) === null || _c === void 0 ? void 0 : _c.short),
            };
            if (_data && paramsRef.current.trend) {
                params[paramsRef.current.trend] = mergeParams(_data);
            }
            return params;
        }, [requireField]);
        const getNewTradeInfo = (0, react_1.useCallback)((p) => {
            const params = p ? p : getRequestInfo();
            return (0, apis_1.hedgeGridParamsCheckAPI)(params);
        }, [getRequestInfo]);
        const queryApi = (0, react_1.useCallback)(() => {
            if (!paramsRef.current.isFocused) {
                return;
            }
            const params = getRequestInfo();
            if ((!params.long && !params.short) || // 没有数据
                (params.long && !requireFieldCheck(params.long)) || // 参数不全
                (params.short && !requireFieldCheck(params.short))) {
                setTradeInfo(undefined);
                return;
            }
            setLoading(true);
            (0, apis_1.hedgeGridParamsCheckAPI)(params)
                .pipe((0, operators_1.catchError)(() => {
                var _a, _b;
                if ((_a = params.long) === null || _a === void 0 ? void 0 : _a.quote_investment) {
                    params.long.quote_investment = "0";
                }
                if ((_b = params.short) === null || _b === void 0 ? void 0 : _b.quote_investment) {
                    params.short.quote_investment = "0";
                }
                return (0, apis_1.hedgeGridParamsCheckAPI)(params);
            }))
                .subscribe({
                next: (res) => {
                    setTradeInfo(res);
                    setLoading(false);
                },
                error: () => {
                    setTradeInfo(undefined);
                    setLoading(false);
                },
            });
        }, [getRequestInfo, requireFieldCheck]);
        const debounceQuery = (0, react_1.useRef)((0, lodash_1.debounce)(queryApi, 500));
        const throttleQuery = (0, react_1.useRef)((0, lodash_1.throttle)(queryApi, 5000));
        // 处理用户输入
        (0, react_1.useEffect)(() => { var _a; return (_a = debounceQuery.current) === null || _a === void 0 ? void 0 : _a.call(debounceQuery); }, [data, orderData, trend]);
        // 处理价格变换
        (0, react_1.useEffect)(() => { var _a; return (_a = throttleQuery.current) === null || _a === void 0 ? void 0 : _a.call(throttleQuery); }, [currentPrice]);
        return { loading, tradeInfo, getNewTradeInfo };
    };
    // 调整保证金预检查
    GridV4FuturesHedgeGridProcessor.useHedgeGridMarginCheckInfo = (params) => {
        const { currentPrice, data, id } = params;
        const dataRef = (0, react_1.useRef)(params);
        dataRef.current = params;
        const [checkInfo, setCheckInfo] = (0, react_1.useState)();
        const [loading, setLoading] = (0, react_1.useState)(false);
        const [error, setErrors] = (0, react_1.useState)();
        const queryApi = (0, react_1.useCallback)(() => {
            const _data = dataRef.current.data;
            if (!dataRef.current.id || !_data || !_data.extra_margin || (!_data.long_open_price && !_data.short_open_price)) {
                return;
            }
            setLoading(true);
            const _params = {
                type: _data.type,
                extra_margin: _data.extra_margin,
            };
            if (_data.long_open_price) {
                _params["long_open_price"] = dataRef.current.currentPrice;
            }
            if (_data.short_open_price) {
                _params["short_open_price"] = dataRef.current.currentPrice;
            }
            (0, apis_1.hedgeGridMarginSettingCheckAPI)(dataRef.current.id, _params).subscribe({
                next: (res) => {
                    setCheckInfo(res);
                    setErrors(undefined);
                    setLoading(false);
                },
                error: (e) => {
                    setCheckInfo(undefined);
                    setErrors(e);
                    setLoading(false);
                },
            });
        }, []);
        const debounceQuery = (0, react_1.useRef)((0, lodash_1.debounce)(queryApi, 500));
        const throttleQuery = (0, react_1.useRef)((0, lodash_1.throttle)(queryApi, 5000));
        // 处理用户输入
        (0, react_1.useEffect)(() => { var _a; return (_a = debounceQuery.current) === null || _a === void 0 ? void 0 : _a.call(debounceQuery); }, [data.extra_margin, id]);
        // 处理价格变换
        (0, react_1.useEffect)(() => { var _a; return (_a = throttleQuery.current) === null || _a === void 0 ? void 0 : _a.call(throttleQuery); }, [currentPrice]);
        return { loading, error, checkInfo };
    };
    // 调整保证金下单
    GridV4FuturesHedgeGridProcessor.marginSettingSubmit = ({ id, data }) => {
        return (0, apis_1.hedgeGridMarginSettingAPI)(id, data).pipe((0, operators_1.mergeMap)((res) => {
            return (0, trade_utils_lib_1.requestWithRetry)(() => (0, apis_1.hedgeGridMarginRecordAPI)(id, { type: "margin" }).pipe((0, operators_1.mergeMap)((r) => {
                const data = r === null || r === void 0 ? void 0 : r.results;
                if (data) {
                    const findResult = data.find((item) => item.transfer_id === res.transfer_id);
                    if (findResult && (findResult.status === "error" || findResult.status === "success")) {
                        return (0, rxjs_1.of)(findResult);
                    }
                    else {
                        throw new Error();
                    }
                }
                else {
                    throw new Error();
                }
            })), {
                maxRetryCount: 15,
                name: "queryHedgeGridMarginRecordObservable",
            });
        }));
    };
    // 修改自定义名称
    GridV4FuturesHedgeGridProcessor.modifyBotName = (id, name) => {
        return (0, apis_1.hedgeGridCustomizeName)(id, { customize_name: name });
    };
    // 添加笔记
    GridV4FuturesHedgeGridProcessor.modifyOrderNode = (id, note) => {
        return (0, apis_1.hedgeGridOrderNode)(id, { note });
    };
    // 修改单边网格止盈止损
    GridV4FuturesHedgeGridProcessor.modifySLTPSettingSubmit = ({ id, data }) => {
        return (0, apis_1.hedgeGridTrendSLTPSettingAPI)(id, data);
    };
    GridV4FuturesHedgeGridProcessor.getGridHedgeFuturesTpSlTrendInfo = ({ exchangeOrder, currentTrend, type, $st, avgPricePrecision, }) => {
        if (exchangeOrder.orderType !== TradeAPILib_1.ExchangeOrderType.gridV4FuturesHedgeGrid) {
            return undefined;
        }
        const innerOrder = exchangeOrder.exchangeGridV4FuturesHedgeGridOrder;
        if (!innerOrder[currentTrend]) {
            return undefined;
        }
        const trendOrder = innerOrder[currentTrend];
        return {
            top: new trade_utils_lib_1.SafeDecimal(trendOrder.high).toString(),
            bottom: new trade_utils_lib_1.SafeDecimal(trendOrder.low).toString(),
            stop_type: type === "tp" ? trendOrder.profit_stop_type : trendOrder.loss_stop_type,
            price: type === "tp" ? trendOrder.profit_stop : trendOrder.loss_stop,
            delay: type === "tp" ? trendOrder.profit_stop_delay : trendOrder.loss_stop_delay,
            liquidTitle: currentTrend === TradeAPILib_1.GridFuturesTrend.long ? $st("hedge_grid_long_liquid_label") : $st("hedge_grid_short_liquid_label"),
            liquidPrice: {
                up: trendOrder.estimate_liquidation_price_up,
                down: trendOrder.estimate_liquidation_price_down,
            },
            avgOpenPrice: new trade_utils_lib_1.SafeDecimal(trendOrder.position_open_price)
                .toDecimalPlaces(avgPricePrecision !== null && avgPricePrecision !== void 0 ? avgPricePrecision : 5, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                .toString(),
            totalProfit: trendOrder.totalProfit,
            totalProfitPercent: trendOrder.totalProfitPercent,
            isConditionAndNotTriggered: trendOrder.isConditionAndNotTriggered,
            trigger: !(0, lodash_1.isUndefined)(trendOrder.condition) ? new trade_utils_lib_1.SafeDecimal(trendOrder.condition).toFixed() : undefined,
        };
    };
})(GridV4FuturesHedgeGridProcessor || (exports.GridV4FuturesHedgeGridProcessor = GridV4FuturesHedgeGridProcessor = {}));
